module.exports = __webpack_public_path__ + "assets/img/i_pay3.39ddd096.png";